import { Component, type PropsWithChildren } from 'react';
import { api } from './api';
export default class ErrorBoundary extends Component<PropsWithChildren,{failed:boolean}> {
  state={failed:false};
  static getDerivedStateFromError(){return {failed:true};}
  componentDidCatch(){void api('/diagnostics','POST',{platform:'web',release:'0.2.0',code:'render_failed',screen:'unknown'}).catch(()=>{});}
  render(){return this.state.failed?<main className="loading-page"><h1>Let’s try that again.</h1><p>Relay couldn’t display this screen. Reload to reconnect to your account.</p><button className="button primary" onClick={()=>location.reload()}>Reload Relay</button></main>:this.props.children;}
}
